// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2OQ9p","title":"Info_title__24sBh","selects":"Info_selects__1rU_m","requiredAsterisk":"Info_requiredAsterisk__21uVK"};